import { Button, Tooltip, ButtonStyles } from '@silverfort/sf-components';
import React, { FC } from 'react';

interface Props {
    onGenerate: () => void;
    onSaveSettings: () => void;
    errors: string | null;
    generateLoading: boolean;
    saveSettingsLoading: boolean;
}

const RiskReportFooter: FC<Props> = ({ onGenerate, onSaveSettings, errors, generateLoading, saveSettingsLoading }) => {
    return (
        <div className="flex flex-1 justify-end gap-2">
            <Button
                text="Save Report Settings"
                disabled={saveSettingsLoading}
                onClick={onSaveSettings}
                buttonStyle={ButtonStyles.Primary}
            />
            {errors ? (
                <Tooltip title="" description={errors} className="w-fit h-fit">
                    <Button disabled={!!errors} text="Generate Report" onClick={onGenerate} />
                </Tooltip>
            ) : (
                <Button disabled={generateLoading} text="Generate Report" onClick={onGenerate} />
            )}
        </div>
    );
};

export default RiskReportFooter;
